import { all } from "redux-saga/effects";
import { onSSOLogin, onGetAcc, getCapb, fetchUserPreference, saveUserPreference } from "./profile/profileSaga";
import {
    onHideCrProj, onShowCrProj, onShowLoader, onHideLoader, onSetView, onHideUpdProj, onShowUpdProj, onShowCopyProj, onFetchLookup,
    onConfRoutCheck,
    onGetConfSessionID,
    onConfCreateQuote,
    onConfUpdateQuote
} from "./ctrl/ctrlSaga";
import {
    onCreateProj, onFetchProjects, onUpdateProj, onCopyProject, onFetchMasterProjects, onFetchPkgs, onCreatePkg,
    onResetPkgsTags, onCreateTag, onFetchTags, onUpdateTag, onFetchADName, onCrPkg, onGetPkgs, onUpPkg, onCreateTT,
    onFetchTT, onFetchTagCount, onCancleFetchTags, onCopyTag, onRemoveTag, addUpdatePriceConfigSaga, onGetModelBreak, onGetReport, onFetchReportHubStatus, onGetReportHubTaskStatus, onGetModelBreakMulti, onSendEmail,
    onSubmitReportBatches,
    onBulkTagConfig,
    onBulkTagConfigStatus, onPostPricingData,
    onBulkTagConfigCancel, onFetchTagPkgCount,
    onSubmitPriceItem,
    onItemPriceStatus,
    onQuoteSearch,
    onFetchTagsWithCmnt,
    onFetchPkgCmntHistory,
    onUpdatePkgCmnt,
    onEditPkgCmnt,
    confITModelBreakdownSaga
} from "./project/projSaga";
import { onCreatePrjAsn, onFetchPrjAsn, onSetPrjAsn, onUpdatePrjAsn } from "./prjasn/prjAsnSaga";
import { onCreateRevision, onDuplicateLine, onUpdateRevision } from "./revision/revSaga";
import { onFetchActivePGApps, onGetUnreadNotification, onUpdateNotification } from "./app/appSaga";

export default function* rootSaga() {
    yield all([
        onSSOLogin(),
        onGetAcc(),
        onHideCrProj(),
        onShowCrProj(),
        onShowLoader(),
        onHideLoader(),
        onCreateProj(),
        onSetView(),
        onFetchProjects(),
        onShowUpdProj(),
        onHideUpdProj(),
        onUpdateProj(),
        onShowCopyProj(),
        onCopyProject(),
        onFetchMasterProjects(),
        onFetchPkgs(),
        onCreatePkg(),
        onResetPkgsTags(),
        onCreateTag(),
        onFetchTags(),
        onUpdateTag(),
        onFetchADName(),
        onCrPkg(),
        onGetPkgs(),
        onFetchPrjAsn(),
        onCreatePrjAsn(),
        onSetPrjAsn(),
        onUpdatePrjAsn(),
        onUpPkg(),
        onCreateTT(),
        onFetchTT(),
        getCapb(),
        onCreateRevision(),
        onUpdateRevision(),
        onFetchTagCount(),
        onCancleFetchTags(),
        onFetchActivePGApps(),
        onDuplicateLine(),
        onCopyTag(),
        onRemoveTag(),
        addUpdatePriceConfigSaga(),
        onGetModelBreak(),
        onGetReport(),
        onSubmitReportBatches(),
        onFetchReportHubStatus(),
        onGetReportHubTaskStatus(),
        onSendEmail(),
        onGetModelBreakMulti(),
        onBulkTagConfig(),
        onBulkTagConfigStatus(),
        onPostPricingData(),
        onBulkTagConfigCancel(),
        onFetchTagPkgCount(),
        onSubmitPriceItem(),
        onFetchLookup(),
        onItemPriceStatus(),
        onQuoteSearch(),
        onFetchTagsWithCmnt(),
        onUpdateNotification(),
        onFetchPkgCmntHistory(),
        onUpdatePkgCmnt(),
        onEditPkgCmnt(),
        onGetUnreadNotification(),

        fetchUserPreference(),
        saveUserPreference(),
        onConfRoutCheck(),
        onGetConfSessionID(),
        onConfCreateQuote(),
        onConfUpdateQuote(),
        confITModelBreakdownSaga(),
    ])
}